import {timeQuery} from 'helpers/Utils'

export class Article {
  id: number
  code: number
  reference: string
  barcode: number
  name: string
  description: string
  image?: string
  cost: number
  margin: number
  price: number
  tax: number
  family: number
  disabled: boolean
  stockable: boolean
  updated: Date

  constructor(props: Article) {
    Object.assign(this, props)
    this.updated = new Date(props.updated)
    this.image = timeQuery(props.image, this.updated)
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Articles/Model.ts